import React from 'react';
import PaginationEndIcon from '../assets/icons/chevron-end.svg';
import PaginationNextIcon from '../assets/icons/chevron-right.svg';

const Pagination = ({
    pagination,
    setPagination,
    loading = false
}: {
    pagination: { pageNumber: number, totalPages: number, dataLength: number, pageLimit: number },
    setPagination: any,
    loading: boolean,
}) => {

    const handlePageLimitChange = (e: any) => {
        const newLimit = Number(e.target.value);

        setPagination({ ...pagination, pageLimit: newLimit, pageNumber: 1 })
    }

    const handleFirstPage = () => {
        setPagination({ ...pagination, pageNumber: 1 })
    }

    const handleLastPage = () => {
        setPagination({ ...pagination, pageNumber: pagination.totalPages })
    }

    const handlePrevPage = () => {
        setPagination({ ...pagination, pageNumber: pagination.pageNumber - 1 })
    }


    const handleNextPage = () => {
        setPagination({ ...pagination, pageNumber: pagination.pageNumber + 1 })
    }


    return <div className="pagination-container">
        <div className="pagination_options">
            <div className="pagination_option">
                <span>Rows per page</span>
            </div>
            <div className="pagination_option">
                <select
                    className="select-pagination"
                    onChange={(e) => handlePageLimitChange(e)}
                    defaultValue={pagination.pageLimit}
                >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
                <svg
                    className="chevron"
                    focusable="false"
                    preserveAspectRatio="xMidYMid meet"
                    viewBox="0 0 40 40"
                >
                    <g>
                        <path d="m37.6 18l-16.6 16.6q-0.4 0.4-1 0.4t-1-0.4l-16.6-16.6q-0.4-0.4-0.4-1t0.4-1l3.7-3.7q0.5-0.4 1-0.4t1 0.4l11.9 11.9 11.9-11.9q0.4-0.4 1-0.4t1 0.4l3.7 3.7q0.4 0.4 0.4 1t-0.4 1z" />
                    </g>
                </svg>
            </div>
            <div className="pagination_option">
                <span>
                    {pagination.pageNumber > 1
                        ? pagination.pageLimit * pagination.pageNumber - (pagination.pageLimit - 1)
                        : 1}
                    -
                    {pagination.dataLength >= pagination.pageLimit * pagination.pageNumber
                        ? pagination.pageLimit * pagination.pageNumber
                        : pagination.dataLength}{' '}
                    of {pagination.dataLength}
                </span>
            </div>
            <div className="pagination_option arrows">
                <div>
                    <button
                        disabled={pagination.pageNumber <= 1 || loading}
                        onClick={() => handleFirstPage()}
                    >
                        <PaginationEndIcon
                            className={`left_end_icon ${pagination.pageNumber <= 1 ? 'disabled' : ''
                                }`}
                        />
                    </button>
                </div>

                <div>
                    <button
                        disabled={pagination.pageNumber <= 1 || loading}
                        onClick={() => handlePrevPage()}
                    >
                        <PaginationNextIcon
                            className={`prev_icon ${pagination.pageNumber <= 1 ? 'disabled' : ''}`}
                        />
                    </button>
                </div>

                <div>
                    <button
                        disabled={
                            pagination.pageNumber >= pagination.totalPages || loading
                        }
                        onClick={() => handleNextPage()}
                    >
                        <PaginationNextIcon
                            className={`next_icon ${pagination.pageNumber >= pagination.totalPages ? 'disabled' : ''
                                }`}
                        />
                    </button>
                </div>

                <div>
                    <button
                        disabled={
                            pagination.pageNumber >= pagination.totalPages || loading
                        }
                        onClick={() => handleLastPage()}
                    >
                        <PaginationEndIcon
                            className={`right_end_icon ${pagination.pageNumber >= pagination.totalPages ? 'disabled' : ''
                                }`}
                        />
                    </button>
                </div>
            </div>
        </div>
    </div>
}

export default Pagination;